module.exports = "Data Display components are used to present data in an approachable way."